import { toggleClass } from 'utils/toggle-classlist'

export const toggleSpinner = (button: HTMLButtonElement): void => {
  toggleClass(button, 'is-with-spinner-shown')
  toggleClass(button.querySelector<HTMLElement>('[data-spinner-spin]'), 'is-hidden')
  toggleClass(button.querySelector<HTMLElement>('[data-spinner-overlay]'), 'is-shown')
}
